<template>
  <div>
    <!-- <div class="homework-content-right-homework" v-for="(item,index) in list" :key="index">
        <div class="homework-content-right-homework-left">
            <img src="../../assets/image/zip.png" alt="">
            <div class="homework-content-right-homework-left-right">
                <div>{{item.name}}</div>
                <div>{{new Date(item.raw.lastModifiedDate).toLocaleString()}}</div>
            </div>
        </div>
        <div class="homework-content-right-homework-right" @click="handleRemove(index)">
            <img src="../../assets/image/whileDel.png" alt="">
            <span>删除</span>
        </div>
    </div> -->
    <el-upload
      ref="my-upload"
      :limit="limit"
      v-loading="loading"
      :action="qiniu.actionPath"
      :data="qiniu.postData"
      :style="{ width: width, height: height }"
      :disabled="disabled"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :on-success="uploadSuccess"
      :accept="accept"
      class="uploadtext"
    >
      <!-- <el-button class="btn" :disabled="disabled">{{text}}</el-button> -->
      <!-- <span>+</span>{{ text }} -->
      <img src="../../assets/image/upimg.png" alt="" style="width:100%;height:80px;">
      <!-- <div style="display: flex;justify-content: center;align-items: center;width:100%;line-height:80px;"><span>+</span>{{ text }}</div> -->
    </el-upload>
  </div>
</template>

<script>
import { getQiniuToken } from "@/api/common";
import { guid } from "@/utils/index";

export default {
  name: "UploadOneFile",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: "",
    },
    file_url: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    // 允许上传个数
    limit: {
      type: Number,
      default: 1,
    },
    width: {
      type: String,
      default: "267px",
    },
    height: {
      type: String,
      default: "80px",
    },
  },

  data() {
    return {
      loading: false,
      qiniu: {
        actionPath: "",
        baseUrl: "",
        postData: {},
      },
      list: [],
    };
  },

  created() {
    getQiniuToken().then((response) => {
      // token可多次使用
      this.qiniu.actionPath = response.data.uploadUrl;
      this.qiniu.baseUrl = response.data.baseUrl;
      if (!this.qiniu.postData.token) {
        this.qiniu.postData.token = response.data.token;
      }
    });
  },

  methods: {
    handleRemove(index) {
      this.list.splice(index, 1);
      this.$refs["my-upload"].clearFiles();
      this.$emit("del");
    },
    beforeUpload(file) {
      // 上传前需生成图片的GUID唯一名
      // console.log(file,'resres')
      this.qiniu.postData.key =
        guid() + "." + file.name.split(".")[file.name.split(".").length - 1];
      this.loading = true;
    },
    uploadSuccess(res, file, list) {
      console.log(res, "res");
      let url = this.qiniu.baseUrl + "/" + res.key;
      this.list.push(file);
      console.log(this.list, "this.list");
      let object = {
        name: file.name,
        url: url,
      };
      this.$emit("update", object);
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-upload{
  width: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.uploadtext {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  background: #f9fafd;
  span {
    font-size: 30px;
    margin-right: 10px;
  }
}
.ma {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.one {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  //  margin-left:30px;
  // margin-top: 25px;
  img {
    width: 18px;
    height: 18px;
  }
}
.upload_btn {
  //   margin: 15px 0;
  width: 70px;
  height: 31px;
  background: linear-gradient(125deg, #437bf4 0%, #2150f4 100%);
  opacity: 1;
  border-radius: 8px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.file_bg {
  background: #f8f8f8;
}
.upload-list-component {
  margin: 15px 0;
  // border: 1px dashed #d9d9d9;
  border-radius: 6px;
  //   cursor: pointer;
  position: relative;
  overflow: hidden;
  //   width: 100%;
  height: 100%;
  margin-right: 10px;
  //   margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .upload-list-component-icon {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #8c939d;
  }
  .upload-list-component-image {
    width: 100%;
    height: 100%;
    display: block;
  }
  .upload-list-component-option {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 18px;
    color: white;
    option-icon {
      flex: 1 1 auto;
    }
  }
}
.upload-list-component .upload-list-component-icon:hover {
  border-color: #409eff;
}
.image-container {
  display: flex;
  flex-wrap: wrap;
}
.upload-list-component:hover {
  border-color: #409eff;
}
.btn {
}
</style>